import { FunctionComponent } from "react";
import TopNav from "../../components/navigation/TopNav";
import Header from "../../components/website/landing/Header"
import Footer from "../../components/website/Footer";
import Contact from "../../components/website/Contact";
import MainContent from "../../components/website/landing/MainContent";
import Testimonials from "../../components/website/Testimonials";
import MobileNav from "../../components/navigation/MobileNav";
import Reviews from "src/components/website/Testimonials/Reviews";


const LandingPage: FunctionComponent = () => (
    <div className="max-w-[1440px] mx-auto w-full">
        <TopNav />
        <MobileNav />
        <Header/>
        <MainContent />
        <Reviews />
        <Contact />
        <Footer />
    </div>
);


export default LandingPage;